/**
 * This fixes youtube playing muted if play is pressed while it's loading
 */
export default (player) => {
  player.on("statechange", (e) => {
    // only playing
    if (e.detail.code !== 1) {
      return;
    }

    // not autoplay
    if (e?.detail?.plyr?.config?.mutedAutoplay) {
      return;
    }

    player.muted = false;
  });
};
